// extracted by mini-css-extract-plugin
export default {"r_l":"_2fb39d0b06 cb15d39e62","t":"_2b3689998f"};